import { forwardRef } from "react";
import type { HTMLAttributes } from "react";
import "./Badge.css";

export type BadgeTone = "neutral" | "success" | "warning" | "danger" | "info" | "brand";
export type BadgeVariant = "solid" | "soft" | "outline";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  variant?: BadgeVariant;
}

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(" ");

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { tone = "neutral", variant = "soft", className, children, ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      className={cx("go4-badge", `go4-badge--${variant}`, `go4-badge--tone-${tone}`, className)}
      {...rest}
    >
      {children}
    </span>
  );
});
